export const ElementoBase = Object.freeze({
  ETIQUETA: 1,
  TERMO_ENCOGIBLE: 2,
  FLEXIBLE: 3,
  CONSUMIBLE: 4,
  CAJA: 5,
  LIBRO_INTERNO: 6,
  LIBRO_TAPA: 7,
  EXTRUSION: 8,
  BOLSAS_FUELLE: 9,
  BOLSAS_BOX: 10,
  OFFSET: 11,
});
